module.exports = __webpack_public_path__ + "static/media/109617.279196e3.svg";